<template>
  <div v-if="$store.state.user" class="mesInfos compteTab">
    <h2>Mes informations personnelles</h2>
    <div class="form">
      <div class="label">
        <label>Mon pseudo</label>
      </div>
      <div class="value">
        <Pseudo :profile="$store.state.profile" />
      </div>
      <div class="label">
        <label>Mon Email</label>
      </div>
      <div class="value">
        <input ref="email" @input="emailChange" v-model="$store.state.user.email" type="email" />
      </div>
      <div class="label">
        <label>Mon mot de passe</label>
      </div>
      <div class="value">
        <input
          ref="password"
          v-model="password"
          :disabled="disabledPass"
          type="password"
          value="********"
          minlength="5"
          required
          @input="validate"
          class="password"
        />
        <a v-show="disabledPass" href="#" @click.prevent="modPass" class="modifier pinkLink">Modifier</a>
      </div>
      <div class="label">
        <label>Mon code postal</label>
      </div>
      <div class="value">
        <input v-model="zip" type="text" @input="validate" />
      </div>
      <div class="label">
        <label>Ma ville</label>
      </div>
      <div class="value">
        <Ville :zip="zip" @input="cityChange" />
      </div>

      <div class="value">
        <span @click.prevent="save" :disabled="!canSave" class="bouton">Enregistrer</span>
      </div>
    </div>
    <h2>Désinscription</h2>

    <span @click.prevent="disablePrf" class="bouton desac">Supprimer mon profil</span>
  </div>
</template>

<script>
import Pseudo from "@/components/profile/Pseudo";
import Ville from "@/components/compte/Ville";
import Vue from "vue";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "MesInfos",
  components: { Pseudo, Ville },

  data() {
    return {
      changed: false,
      valid: false,
      villeMods: 3,
      zip: "",
      disabledPass: true,
      password: "********",
      idCity: null
    };
  },

  computed: {
    s: function() {
      if (this.villeMods > 1) return "s";
      return "";
    },

    e: function() {
      if (this.$store.state.profile.sex == "FEMALE") return "e";
      else return "";
    },

    canSave: function() {
      return this.changed && this.valid;
    }
  },

  methods: {
    init: function() {
      this.zip = this.$store.state.profile.city.zip;
    },

    modPass: async function() {
      this.disabledPass = false;
      this.password = "";
      this.changed = false;
      await Vue.nextTick();
      this.$refs.password.focus();
    },

    validate: function() {
      this.changed = true;
      this.valid = this.idCity !== null && this.$refs.email.reportValidity() && this.$refs.password.reportValidity();
    },

    cityChange: function(val) {
      if (val) {
        this.idCity = val;
      } else {
        this.idCity = null;
      }

      this.validate();
    },

    emailChange: async function(val) {
      let validEmail = await idyuJsonRpc("checkEmail", val.currentTarget.value);
      if (validEmail === false) {
        this.$refs.email.setCustomValidity("Cette adresse email est déjà utilisée.");
      } else {
        this.$refs.email.setCustomValidity("");
      }
      this.validate();
    },

    save: async function() {
      if (!this.canSave) {
        return;
      }

      if (this.changed) {
        let id = 0;
        try {
          id = parseInt(this.idCity);
        } catch {
          //
        }
        idyuJsonRpc("savePersonalInformation", this.$store.state.user.email, this.password, id);
        this.changed = false;
        await alert("Informations enregistrées !");
      }
    },

    disablePrf: async function() {
      if (await confirm("Êtes-vous certain" + this.e + " de vouloir supprimer votre profil ?")) {
        await idyuJsonRpc("deleteOwnProfile");
        await alert("Votre profil a bien été supprimé.");
        this.$router.push({ name: "Inscription" });
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";
@import "@/assets/css/forms.scss";
@import "@/assets/css/compte.scss";

input,
select {
  max-width: 300px !important;
}

.label {
  text-align: right;
}

.modif {
  font-style: italic;
  color: #aaa;
}

.modifier {
  margin-left: 0px;
  display: inline-block;
  margin-top: 5px;
}

.password {
  margin-right: 10px;
}

input:invalid {
  border-color: red;
  border-width: 2px;
  &:focus {
    box-shadow: none !important;
  }
}

@media screen and (max-width: 540px) {
  .desac {
    max-width: none;
  }
}

@media screen and (max-width: 680px) {
  .form {
    grid-template-columns: auto !important;
    grid-template-rows: auto !important;
    grid-gap: 5px;
    .value {
      grid-column: 1 !important;
    }

    .label {
      padding-left: 3px;
      padding-bottom: 0px;
      text-align: left;
      width: auto;
    }
  }
}
</style>
